import { api } from '@/core/lib/api-client';

/* ── Response types ─────────────────────────────────────────────────── */

export interface PublicHotel {
  id: string;
  name: string;
  slug: string;
  description?: string;
  address?: string;
  city: string;
  country: string;
  starRating: number;
  propertyType?: string;
  latitude?: number;
  longitude?: number;
  priceRange?: { min: number; max: number; currency: string };
  priceFrom?: number;
  currency?: string;
  amenities: string[];
  images?: string[];
  mainImage?: string;
  rating: number;
  reviewCount: number;
  featured?: boolean;
}

export interface PublicRoom {
  id: string;
  name: string;
  type: string;
  description: string;
  maxOccupancy: number;
  bedType: string;
  pricePerNight: number;
  currency: string;
  amenities: string[];
  images: string[];
  available: boolean;
}

export interface PaginationMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

type Params = Record<string, string | number | boolean | undefined>;

/* ── Service ────────────────────────────────────────────────────────── */

export class HotelsService {
  static async listPublic(params?: Params) {
    return api.get<{ data: PublicHotel[]; meta?: PaginationMeta }>(
      '/public/hotels',
      { params },
    );
  }

  static async getBySlug(slug: string) {
    return api.get<{ data: PublicHotel }>(`/public/hotels/${slug}`);
  }

  static async getRoomsBySlug(slug: string, params?: Params) {
    return api.get<{ data: PublicRoom[] }>(`/public/hotels/${slug}/rooms`, { params });
  }

  static async getRoomTypes() {
    return api.get<{ data: Record<string, unknown>[] }>('/public/hotel-room-types');
  }

  static async getHotelReviews(slug: string) {
    return api.get<{ data: HotelReview[] }>(`/public/hotels/${slug}/reviews`);
  }
}

export interface HotelReview {
  id: string;
  author: string;
  rating: number;
  date: string;
  verified: boolean;
  text: string;
}
